module.exports = __webpack_public_path__ + "static/bgpattern-05866271efba50f2b39765f0ca79f911.svg";